import React from "react";
import { Container } from "react-bootstrap";

const PitchFeasibility = () => {
  return (
    <>
      <section className="py-5">
        <Container>
          <p className="section-subtitle  text-start mb-2 px-3 pb-3">
            Cash Flows
          </p>
          {/* first table */}
          <div className="scroll-x">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Year</th>
                <th>Inflow</th>
                <th>Outflow</th>
                <th>Net Cash Flows</th>
                <th>Discount Factor</th>
                <th>PV</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0</td>
                <td>$</td>
                <td> $(84,000,000)</td>
                <td> $(84,000,000)</td>
                <td>1.000</td>
                <td> $(84,000,000)</td>
              </tr>
              <tr>
                <td>1</td>
                <td> $12,850,805,961</td>
                <td> $5,106,005,961</td>
                <td> $7,744,800,000</td>
                <td> 0.917</td>
                <td> $7,105,321,101</td>
              </tr>
              <tr>
                <td>2</td>
                <td> $51,983,680,251</td>
                <td> $(27,478,168,425)</td>
                <td> $24,505,511,826</td>
                <td> 0.842</td>
                <td> $20,625,799,029</td>
              </tr>
              <tr>
                <td>3</td>
                <td> $103,604,103,813</td>
                <td> $(62,343,285,480)</td>
                <td> $41,260,818,333</td>
                <td> 0.772</td>
                <td> $31,860,922,291</td>
              </tr>
              <tr>
                <td>4</td>
                <td> $162,846,720,000</td>
                <td> $(98,768,078,280)</td>
                <td> $64,078,641,720</td>
                <td> 0.708</td>
                <td> $45,394,925,285</td>
              </tr>
              <tr>
                <td>5</td>
                <td> $231,575,040,000</td>
                <td> $(124,312,773,000)</td>
                <td> $107,262,267,000</td>
                <td> 0.650</td>
                <td> $69,713,113,889</td>
              </tr>
              <tr className="lead-row">
                <td> $562,860,350,025</td>
                <td> $(318,092,311,146)</td>
                <td> $244,768,038,879</td>
                <td>$107,584,520,000</td>
                <td className="active start-cell">NPV</td>
                <td className="active"> $174,616,081,594</td>
              </tr>
              <tr>
                <td></td>
                <td>Positive Cash Flow..</td>
                <td> $48,953,607,776</td>
                <td></td>
                <td className="active lead-cell start-cell">
                  Payback Period (Years)
                </td>
                <td className="active lead-cell">0.37</td>
              </tr>
              <tr>
                <td></td>
                <td>Capital + Loan</td>
                <td> $18,286,910,025</td>
                <td></td>
                <td className="active-dark lead-cell start-cell">IRR</td>
                <td className="active-dark lead-cell">9432%</td>
              </tr>
              <tr className="lead-row">
                <td></td>
                <td>Conclusion:</td>
                <td colSpan={4}>
                  The Project is Feasible because the NPV is Greater than Zero
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </Container>
      </section>
      {/* second table */}
      <section className="py-5">
        <Container>
          <div className="scroll-x table-white pb-3">
            <table className="custom-table table-white">
              <thead>
                <tr>
                  <th>CAPEX + Loan Repayment</th>
                  <th>COGS</th>
                  <th>OPEX</th>
                  <th>Interest, Dividend & Tax</th>
                  <th>Outflow</th>
                  <th>Sales Revenues</th>
                  <th>Capital + Loan</th>
                  <th>Inflows</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> $84,000,000</td>
                  <td> $1,991,808,000</td>
                  <td> $2,663,796,660</td>
                  <td> $450,401,301</td>
                  <td> $5,190,005,961</td>
                  <td> $7,660,800,000</td>
                  <td> $5,190,005,961</td>
                  <td> $12,850,805,961</td>
                </tr>
                <tr>
                  <td> $216,000,000</td>
                  <td> $11,097,216,000</td>
                  <td> $13,445,464,500</td>
                  <td> $2,719,487,925</td>
                  <td> $27,478,168,425</td>
                  <td> $42,681,600,000</td>
                  <td> $9,302,080,251</td>
                  <td> $51,983,680,251</td>
                </tr>
                <tr>
                  <td> $288,000,000</td>
                  <td> $25,950,412,800</td>
                  <td> $29,445,516,000</td>
                  <td> $6,659,356,680</td>
                  <td> $62,343,285,480</td>
                  <td> $99,809,280,000</td>
                  <td> $3,794,823,813</td>
                  <td> $103,604,103,813</td>
                </tr>
                <tr>
                  <td> $288,000,000</td>
                  <td> $42,340,147,200</td>
                  <td> $44,785,749,600</td>
                  <td> $11,354,181,480</td>
                  <td> $98,768,078,280</td>
                  <td> $162,846,720,000</td>
                  <td> $-</td>
                  <td> $162,846,720,000</td>
                </tr>
                <tr>
                  <td> $336,000,000</td>
                  <td> $60,209,510,400</td>
                  <td> $44,785,749,600</td>
                  <td> $18,981,513,000</td>
                  <td> $124,312,773,000</td>
                  <td> $231,575,040,000</td>
                  <td> $-</td>
                  <td> $231,575,040,000</td>
                </tr>
                <tr className="active">
                  <td> $1,212,000,000</td>
                  <td> $141,589,094,400</td>
                  <td> $135,126,276,360</td>
                  <td> $40,164,940,386</td>
                  <td> $318,092,311,146</td>
                  <td> $544,573,440,000</td>
                  <td> $18,286,910,025</td>
                  <td> $562,860,350,025</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchFeasibility;
